// extracted by mini-css-extract-plugin
export var landing = "Landing-module--landing--2W5Yw";
export var sixpanelContainer = "Landing-module--sixpanelContainer--31WpJ";
export var filterOn = "Landing-module--filterOn--15n7E";
export var overlay = "Landing-module--overlay--dOKAv";
export var fixedCentered = "Landing-module--fixedCentered--2Suv_";
export var textClickHere = "Landing-module--textClickHere--2NBGG";
export var text = "Landing-module--text--3rB46";